import { render, staticRenderFns } from "./date-defaultValue-editor.vue?vue&type=template&id=67b82bde&scoped=true&"
import script from "./date-defaultValue-editor.vue?vue&type=script&lang=js&"
export * from "./date-defaultValue-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b82bde",
  null
  
)

export default component.exports